<template>
    <BRow>
        <BCol>
            <div class="d-flex justify-content-between">
                <div class="d-flex align-items-end mb-3">
                    <h4 class="mb-0">
                        {{ $tc('models.quote') }}:
                    </h4>
                    <span class="text-muted ml-1">{{ model._label }}</span>
                </div>
                <button
                    v-if="canDownloadQuote"
                    class="mt-auto btn btn-primary"
                    type="button"
                    @click="quoteDownload"
                    v-text="$t('quote.download-pdf')"
                />
            </div>

            <div class="mb-3">
                <div class="flex-row">
                    <div class="text-align-end">
                        <span class="font-weight-bold">
                            {{ $t('models.company') }}:
                        </span>

                        <company
                            :link="false"
                            :model-value="model.deal?.company"
                        />
                    </div>
                </div>
                <div class="flex-row">
                    <div class="text-align-end">
                        <span class="font-weight-bold">
                            {{ $tc('models.client') }}:
                        </span>

                        <client
                            :link="false"
                            :model-value="model.deal?.client"
                        />
                    </div>
                </div>
            </div>

            <template v-if="model.status_id === 2">
                <hr>
                <p class="mt-3">
                    {{ $t('quote.header', { name: model.name }) }}
                </p>

                <div class="flex-row mb-2">
                    <div class="text-align-end">
                        <span class="font-weight-bold">
                            {{ $t('quote.name') }}:
                        </span>

                        <BFormInput v-model="name" />
                    </div>
                </div>

                <div class="flex-row mb-2">
                    <div class="text-align-end">
                        <span class="font-weight-bold">
                            {{ $t('quote.note') }}:
                        </span>

                        <BFormTextarea v-model="note" />
                    </div>
                </div>

                <div class="flex-row">
                    <div class="text-align-end">
                        <div class="d-flex justify-content-between align-items-center">
                            <span class="font-weight-bold">
                                {{ $t('quote.signature') }}:
                            </span>

                            <i
                                class="fa fa-undo cursor-pointer text-primary"
                                :title="$t('actions.again')"
                                @click="$refs.signaturePad.clearSignature()"
                            />
                        </div>

                        <div class="d-flex">
                            <VueSignaturePad
                                ref="signaturePad"
                                class="border rounded mx-auto"
                                width="100%"
                                height="200px"
                                :options="signatureFieldOptions"
                            />
                        </div>
                    </div>
                </div>

                <div
                    v-if="canAcceptQuote"
                    class="flex-row float-right mt-3"
                >
                    <loading-button
                        class="btn btn-success"
                        :loading="loading"
                        type="button"
                        @click="submitSignature"
                    >
                        {{ $t('actions.accept') }}
                    </loading-button>
                </div>
            </template>
            <template v-else-if="model.status_id === 3">
                <p class="text-success">
                    <strong>{{ $t('quote.accepted') }}</strong>
                </p>
            </template>
            <template v-else-if="model.status_id === 4">
                <p class="text-danger">
                    <strong>{{ $t('quote.rejected') }}</strong>
                </p>
            </template>
        </BCol>
    </BRow>
</template>

<script>
import Show from '@/mixins/Show';
import Quote from '@/models/Quote';
import api from '@/services/Api';
import store from '@/store';
import { toast } from 'vue3-toastify';

export default {
    mixins: [Show],
    data () {
        return {
            model_project_phases: [],
            name: '',
            note: '',
            loading: false,
            signatureFieldOptions: {
                penColor: '#000',
            },
        };
    },
    watch: {
        model: {
            handler (value) {
                if (value) {
                    this.name = this.model.deal?.client ? this.model.deal.client.full_name : '';
                }
            },
            immediate: true,
        },
    },
    computed: {
        canDownloadQuote () {
            return store.getters.hasPermission('quotes.download');
        },
        canAcceptQuote () {
            return store.getters.hasPermission('quotes.accept');
        },
    },
    methods: {
        quoteDownload () {
            this.loading = true;
            api.post(`/quotes/${this.model.id}/download`, {}, { responseType: 'blob' })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${this.model._label}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                });

            this.loading = false;
        },
        submitSignature () {
            if (this.loading) {
                return;
            }

            this.loading = true;

            const {
                isEmpty,
                data,
            } = this.$refs.signaturePad.saveSignature();

            if (isEmpty) {
                this.loading = false;
                alert(this.$t('quote.no-signature'));
                return;
            }

            // Create axios call to save pdf with signature.
            Quote.accept(this.model.id, {
                name: this.name,
                note: this.note,
                signature: data,
            }).then((res) => {
                toast(this.$t('quote.accepted'), {
                    type: toast.TYPE.SUCCESS,
                });
            }).finally(() => {
                this.load();
                this.loading = false;
            });
        },
    },
};
</script>
